"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseVideoItem = void 0;
var tslib_1 = require("tslib");
var object_1 = require("@wix/wix-vod-shared/dist/src/common/utils/object");
var video_deal_info_1 = require("@wix/wix-vod-constants/dist/common/video-deal-info");
var transcoding_statuses_1 = require("@wix/wix-vod-constants/dist/common/transcoding-statuses");
var video_sources_1 = require("@wix/wix-vod-constants/dist/common/video-sources");
var time_1 = require("@wix/wix-vod-shared/dist/src/common/utils/time");
var entity_id_1 = require("../normalizers/entity-id");
var mapMediaInfoToLiveStatus_1 = require("@wix/wix-vod-api-site-based/dist/src/utils/mapMediaInfoToLiveStatus");
var api_types_1 = require("@wix/wix-vod-constants/api-types");
var DEFAULT_DOWNLOAD_OPTIONS = { allowDownload: false };
var normalizeTranscodingStatus = function (status) {
    if (_.includes(transcoding_statuses_1.TRANSCODING_STATUSES, status)) {
        return status;
    }
    return transcoding_statuses_1.TRANSCODING_STATUSES.NONE;
};
var mapUsedInLists = function (usedInLists) {
    if (usedInLists === void 0) { usedInLists = []; }
    return usedInLists.map(function (ref) { return ({
        id: ref.itemId,
        title: ref.title,
    }); });
};
var parseVideoItem = function (itemData) {
    var _a;
    var camelCasedItemData = (0, object_1.keysToCamelCase)(itemData);
    var itemId = camelCasedItemData.itemId, externalId = camelCasedItemData.externalId, listId = camelCasedItemData.listId, mediaStatus = camelCasedItemData.mediaStatus, trailerStatus = camelCasedItemData.trailerStatus, mediaInfo = camelCasedItemData.mediaInfo, mediaExternUrl = camelCasedItemData.mediaExternUrl, _b = camelCasedItemData.downloadOptions, _c = _b === void 0 ? DEFAULT_DOWNLOAD_OPTIONS : _b, allowDownload = _c.allowDownload, _d = camelCasedItemData.videoSource, videoSource = _d === void 0 ? video_sources_1.VIDEO_SOURCES.COMPUTER : _d, itemType = camelCasedItemData.itemType;
    var id = (itemId && (0, entity_id_1.normalizeId)(itemId)) || externalId;
    var _e = camelCasedItemData.customCoverUrl, customCoverUrl = _e === void 0 ? null : _e, createdTsNum = camelCasedItemData.createdTs, updatedTsNum = camelCasedItemData.updatedTs, publishTsNum = camelCasedItemData.publishTs, usedInLists = camelCasedItemData.usedInLists;
    var dealInfo = camelCasedItemData.dealInfo, durationSec = camelCasedItemData.durationSec, durationStr = camelCasedItemData.durationStr, _f = camelCasedItemData.tags, tags = _f === void 0 ? [] : _f, _g = camelCasedItemData.categories, categories = _g === void 0 ? [] : _g;
    var createdTs = new Date(createdTsNum * 1000);
    var updatedTs = new Date(updatedTsNum * 1000);
    var publishTs = publishTsNum ? new Date(publishTsNum * 1000) : null;
    var fileInputDurationSec = _.get(mediaInfo, 'fileInput.duration', 0);
    if (fileInputDurationSec) {
        durationSec = Math.floor(fileInputDurationSec / 1000);
        durationStr = (0, time_1.convertSSToMMSS)(durationSec);
    }
    if (!durationStr) {
        durationStr = (0, time_1.convertSSToMMSS)(durationSec);
    }
    var transcodingStatus = normalizeTranscodingStatus(mediaExternUrl ? transcoding_statuses_1.TRANSCODING_STATUSES.READY : mediaStatus);
    var trailerTranscodingStatus = normalizeTranscodingStatus(trailerStatus);
    // external videos should be free
    if (mediaExternUrl) {
        dealInfo = video_deal_info_1.FREE_VIDEO_DEAL_INFO;
    }
    tags = _.uniq(tags);
    categories = _.uniq(categories);
    var normalizedListId = (0, entity_id_1.normalizeId)(listId);
    var clearCamelCasedItemData = _.omit(camelCasedItemData, [
        'downloadOptions',
        'mediaStatus',
        'trailerStatus',
    ]);
    var mapAutogeneratedTrailerInfo = function () {
        var status = normalizeTranscodingStatus(mediaInfo.fileOutput.trailer[0].status);
        if (status === transcoding_statuses_1.TRANSCODING_STATUSES.FAILED) {
            return {
                status: status,
                errorType: api_types_1.TrailerGenerationErrorType.InternalError,
            };
        }
        else {
            return { status: status };
        }
    };
    var mappedCamelCasedItemData = tslib_1.__assign(tslib_1.__assign({}, clearCamelCasedItemData), { id: id, listId: normalizedListId, customCoverUrl: customCoverUrl, transcodingStatus: transcodingStatus, trailerTranscodingStatus: trailerTranscodingStatus, dealInfo: dealInfo, durationSec: durationSec, durationStr: durationStr, createdTs: createdTs, updatedTs: updatedTs, publishTs: publishTs, usedInLists: mapUsedInLists(usedInLists), allowDownload: allowDownload, videoSource: videoSource, tags: tags, categories: categories, liveVideoStatus: (0, mapMediaInfoToLiveStatus_1.mapMediaInfoToLiveVideoStatus)(mediaInfo, itemType), autogeneratedTrailer: ((_a = mediaInfo === null || mediaInfo === void 0 ? void 0 : mediaInfo.fileOutput) === null || _a === void 0 ? void 0 : _a.trailer)
            ? mapAutogeneratedTrailerInfo()
            : undefined });
    return (0, object_1.removeUndefinedValues)(mappedCamelCasedItemData);
};
exports.parseVideoItem = parseVideoItem;
//# sourceMappingURL=video-item.js.map